import { IconButton } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import React from "react";
import CustomTable from "../../../../components/custom-table/CustomTable";

export default function PostList({ tableData, onEditRow, onDeleteRow, ...props }) {

  function buildColumns() {
    let columns = [
      {
        Header: "पद",
        accessor: "name",
      },
    ]
    if (props.showActionColumn) {
      columns.push({
        Header: "सम्पादन",
        accessor: "id",
        className: 'print-none',
        Cell: (row) => (
          <>
            <IconButton onClick={() => onEditRow(row.value)} aria-label="edit">
              <Edit fontSize="small" />
            </IconButton>
            <IconButton onClick={() => onDeleteRow(row.value)} aria-label="delete">
              <Delete fontSize="small" color="secondary" />
            </IconButton>
          </>
        )
      })
    }
    return columns;
  }

  const columns = buildColumns();

  return (
    <CustomTable columns={columns} data={tableData} />
  );
}